import React from 'react';
import styles from './catalog.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { makeRequest } from '../../Utils';
import GhostGrid from '../../components/GhostGrid';
import ProductListItem from '../../components/ProductListItem';
import HomepageBookBlock from '../../components/HomepageBookBlock';

export default function CatalogPage() {
  const [products, setProducts] = useState([]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [loading, setLoading] = useState(true);

  document.title = `Catalog | Asterism Books`;
  document.querySelector('meta[name="description"]').setAttribute('content', `The latest wholesale catalog featuring new releases, bestsellers, publisher spotlights, and more from Asterism.`);

  useEffect(() => {
    if (!products || products.length === 0) return;

    const interval = setInterval(() => {
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      const imageUrl = randomProduct?.cover?.['300'];
      setFeaturedImage(imageUrl);
    }, 4000);

    return () => clearInterval(interval);
  }, [products])


  useEffect(() => {
    const getProducts = async () => {
      // define afterDate as the first moment of March 1, 2026 in ISO format and beforeDate
      const afterDate = new Date('2026-02-28T23:59:59Z').toISOString();
      const beforeDate = new Date('2026-03-31T00:00:00Z').toISOString();
      let data = await makeRequest(`all-products?afterDate=${afterDate}&beforeDate=${beforeDate}&per=100`, 'GET');
      setProducts(data.docs.reverse());
      setLoading(false);
      if (data.docs.length > 0) {
        const randomProduct = data.docs[Math.floor(Math.random() * data.docs.length)];
        const imageUrl = randomProduct?.cover?.['300'];
        setFeaturedImage(imageUrl);
      }
    }
    getProducts();
  }, [])


  return (
    <div>
      <div className={styles.catalogHero}>
        <div className={styles.featuredCover}>
          {featuredImage &&
            <img src={featuredImage} alt="Featured Book Cover" className={styles.featuredImage} />}
        </div>
        <div className={styles.catalogIntro}>
          <div className={styles.catalogIntroHead}>* * *</div>
          <h2>The March List</h2>
          <p>6 p.m. sunsets in the Pacific Northwest, buttercups in bloom, and the latest releases from Asterism Books.</p>
        </div>
        <div className={styles.catalogNews}>
          <h3>News & Updates</h3>
          <ul>
            <li><strong><em>Found Cats</em></strong> is now back in stock!</li>
            <li><strong>New Publishers:</strong> Toad Press, DoulbeCross, etc.</li>
            <li>Asterism Books will be at AWP in Baltimore March 5-7 at Booth 1266</li>
          </ul>
        </div>
      </div>
      <h2>All March New Releases</h2>
      <div className='lowerGrid'>
        {loading && <GhostGrid />}
        {!loading && products.length === 0 && <div>No products matched your request.</div>}
        {products.map((product, index) =>
          <ProductListItem key={product._id} product={product} context='allBooks' />
        )}
      </div>
      <HomepageBookBlock block={0} title={'Back In Stock'} source={'list'} sourceId={'53fc93df-843e-49d8-80bb-4c6c5ffb2bbf'} moreText={null} moreLink={null} />
      <HomepageBookBlock block={0} title={'Recent Bestsellers'} source={'bestsellers'} sourceId={null} moreText={'Previous Bestsellers'} moreLink={'/bestsellers'} />
    </div>
  )
}